import React, { useState } from "react";
import { Card, CardBody, CardTitle, Col, Collapse } from "reactstrap";
import Select from "react-select";
import InputMask from "react-input-mask";
import {
  FiChevronUp,
  FiChevronDown,
  FiTrash2,
  FiPlus,
  FiCalendar,
} from "react-icons/fi";
const HmfFactureEdit = ({
  title,
  data,
  form,
  onAddForm,
  onDeleteForm,
  handleInputChange,
  renderBaseOptions,
  renderOuiNonOptions,
}) => {
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    minWidth: "10em",
  };
  const [isTableAccordionOpen, setIsTableAccordionOpen] = useState(true);

  const toggleTableAccordion = () => {
    setIsTableAccordionOpen(!isTableAccordionOpen);
  };
  return (
    <Col sm="12">
      {data ? (
        <>
          <Card
            className="shadow-sm border-0 overflow-hidden mb-4"
            style={{ borderRadius: "12px" }}
          >
            {/* En-tête cliquable */}
            <div
              className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
              style={{
                background: "#555B21",
                letterSpacing: "0.5px",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={toggleTableAccordion}
            >
              <div className="d-flex align-items-center">
                <span style={{ fontSize: "0.82rem" }}>{title}</span>
              </div>
              {isTableAccordionOpen ? (
                <FiChevronUp size={16} />
              ) : (
                <FiChevronDown size={16} />
              )}
            </div>

            <Collapse isOpen={isTableAccordionOpen}>
              <CardBody className="p-3">
                <Col sm="12">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered rounded-3 overflow-hidden"
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                      }}
                    >
                      {/* Table headers */}
                      <thead>
                        <tr>
                          {data?.header.map((columnName, index) => (
                            <th className="" style={tableaustyles} key={index}>
                              {columnName}
                            </th>
                          ))}
                          <th
                            className=""
                            style={{
                              background: "#555B21",
                              color: "white",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                              width: "1%",
                            }}
                            key="Del"
                          ></th>
                        </tr>
                      </thead>
                      {/* Table body */}
                      <tbody>
                        {form?.map((rowData) => (
                          <tr key={rowData.index}>
                            {/* Table cells */}
                            {Object.entries(rowData).map(([key, value]) => {
                              if (key !== "id" && key !== "index") {
                                return (
                                  <td key={key}>
                                    {key === "fx_base_de_calcul_id" ? (
                                      <select
                                        value={value}
                                        name="fx_base_de_calcul_id"
                                        className="form-control form-control-sm"
                                        onChange={(e) =>
                                          handleInputChange(
                                            rowData.index,
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                      >
                                        {renderBaseOptions}
                                      </select>
                                    ) : key === "reel" ? (
                                      <select
                                        value={value}
                                        name="reel"
                                        className="form-control form-control-sm"
                                        onChange={(e) =>
                                          handleInputChange(
                                            rowData.index,
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        disabled={
                                          title ===
                                            "Produits facturés (échu)" ||
                                          title ===
                                            "Consommation réelle (à échoir)" ||
                                          title ===
                                            "Estimation précédente (à échoir)" ||
                                          title ===
                                            "Estimation suivante (à échoir)"
                                            ? true
                                            : false
                                        }
                                      >
                                        {renderOuiNonOptions}
                                      </select>
                                    ) : key === "addition" ? (
                                      <select
                                        value={value}
                                        name="addition"
                                        className="form-control form-control-sm"
                                        onChange={(e) =>
                                          handleInputChange(
                                            rowData.index,
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        disabled={
                                          title ===
                                            "Produits facturés (échu)" ||
                                          title ===
                                            "Consommation réelle (à échoir)" ||
                                          title ===
                                            "Estimation précédente (à échoir)" ||
                                          title ===
                                            "Estimation suivante (à échoir)"
                                            ? true
                                            : false
                                        }
                                      >
                                        {renderOuiNonOptions}
                                      </select>
                                    ) : key === "extra" ? (
                                      <select
                                        value={value}
                                        name="extra"
                                        className="form-control form-control-sm"
                                        onChange={(e) =>
                                          handleInputChange(
                                            rowData.index,
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        disabled
                                      >
                                        {renderOuiNonOptions}
                                      </select>
                                    ) : key === "debut" ? (
                                      <InputMask
                                        name={key}
                                        mask="99/99/9999"
                                        value={value}
                                        className="form-control form-control-sm input-color"
                                        onChange={(e) =>
                                          handleInputChange(
                                            rowData.index,
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        style={{ width: "100px" }}
                                      />
                                    ) : key === "fin" ? (
                                      <InputMask
                                        name={key}
                                        mask="99/99/9999"
                                        value={value}
                                        className="form-control form-control-sm input-color"
                                        onChange={(e) =>
                                          handleInputChange(
                                            rowData.index,
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        style={{ width: "100px" }}
                                      />
                                    ) : (
                                      <input
                                        className="form-control form-control-sm"
                                        defaultValue={value}
                                        name={key}
                                        onChange={(e) =>
                                          handleInputChange(
                                            rowData.index,
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        disabled={
                                          key === "quantite_consommee" ||
                                          key === "prix_de_vente_ht" ||
                                          key === "prix_de_vente_ttc"
                                            ? true
                                            : false
                                        }
                                      />
                                    )}
                                  </td>
                                );
                              } else {
                                return null;
                              }
                            })}

                            {/* Delete button */}
                            <td>
                              <i
                                className="bx bx-trash"
                                style={{
                                  fontSize: "20px",
                                  paddingTop: "5px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                }}
                                onClick={() => onDeleteForm(rowData.index)}
                              ></i>
                            </td>
                          </tr>
                        ))}
                        {/* Add button */}
                        <tr>
                          <td colSpan="9">
                            <input
                              type="button"
                              style={tableaustyles}
                              className="btn btn-info mt-3 mt-lg-0"
                              value="Ajouter"
                              onClick={onAddForm}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
              </CardBody>
            </Collapse>
          </Card>
        </>
      ) : null}
    </Col>
  );
};

export default HmfFactureEdit;
